<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <poolsidebar></poolsidebar>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <div class="moduleWrapper">
           <unifieddash v-if="LicensePoolID!==null" :LicensePoolID="LicensePoolID" :mode="'0'"></unifieddash>
           <div v-if="LicensePoolID===null">Loading Dashboard...</div>
        </div>
      </div>
    <div class="clearfix"></div></div><acfooter></acfooter>
  </div>
</template>
<script>
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import poolsidebar from "../../layout/Pool/Sidebar.vue"
  import unifieddash from "../../components/UnifiedDash.vue"

  export default {
    name: 'PoolDashboard',
    components: {acheader,acfooter,poolsidebar,unifieddash},
    data() {
      return {
        LicensePoolID:null
      }
    },
    mounted() {
      this.doPage().then(r=>{
        this.bootstrapPool(this.$route.params.id);
        this.LicensePoolID=this.$route.params.id;
      });
    }
  }
</script>
